import { ref, nextTick, computed } from 'vue';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { getPDFCover } from '@/utils/api';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';

export const useReportData = () => {
	const initDone = ref(false);
	const { quarterlyPerformance } = useModuleData();

	// 保持与历史组件相同的数据访问路径和处理逻辑
	const listData = computed(() => {
		const dataObj = quarterlyPerformance.data?.data || {};
		return Object.entries(dataObj)
			.reverse()
			.reduce((prev, [key, values]) => {
				return prev.concat({
					year: key,
					values: values.map(v => {
						return {
							...v,
							cover: ''
						};
					})
				});
			}, []);
	});

	const flattenList = computed(() => {
		return listData.value.reduce((prev, curr) => {
			return prev.concat(curr.values);
		}, []);
	});

	const getReportList = async () => {
		await quarterlyPerformance.refresh({isAll: true});
		initDone.value = true;
	};

	let observer;
	function query(selector) {
		return Array.from(document.querySelectorAll(selector));
	}
	const startCoverObserver = () => {
		nextTick(() => {
			if (!listData.value.length) return;

			observer = new IntersectionObserver(function (changes) {
				changes.forEach(function (entries) {
					if (entries.intersectionRatio > 0) {
						const { parent, child } = entries.target.dataset;
						const { cover, announcementLink } = listData.value[parent].values[child];
						if (!cover) {
							getPDFCover(announcementLink).then(res => {
								listData.value[parent].values[child].cover = res;
							});
						} else {
							const element = entries.target;
							observer.unobserve(element);
						}
					}
				});
			});
			query('.file-cover').forEach(function (item) {
				observer.observe(item);
			});
		});
	};

	const { viewModule } = useModuleNavigation();
	const gotoPerformanceEntry = (comeinLink, id) => {
		viewModule('performance_report', { comeinLink, id });
	};

	return {
		initDone,
		rootLoading: quarterlyPerformance.loading,
		listData,
		flattenList,
		observer,
		startCoverObserver,
		getReportList,
		gotoPerformanceEntry
	};
};
